import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import CalculateForm from "./calculateform"
import LandingHeader from "./landingheader"
import CalculationDetail from "./calculationdetail"
import { useAppDispatch, useAppSelector } from "src/projects/ticarikredi/config/hook"
import { pushGtmValues } from "@bappweb/utils"
import SSSList from "./ssslist"
import { useGetConfigListMutation } from "../../../api/services"
import { setCalcDetails } from "src/projects/ticarikredi/state/calcdetails"
import { getCidParameter, getConfigValue, isNullOrEmpty, SMPUConfigListResponse } from "@smpu-web/utils/utils"

type DefaultValues = {
    minVade: number,
    maxVade: number,
    minAmount: number,
    maxAmount: number
}

const Landing = () => {
    const dispatch = useAppDispatch()
    const [configList, setConfigList] = useState<SMPUConfigListResponse[]>()
    const [faqText, setFaqText] = useState<any[]>([]);
    const [getConfigList] = useGetConfigListMutation();
    useEffect(() => {
        getConfigList({
            functionCode: "KRD0002",
            cid: getCidParameter() ?? "",
            TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        })
            .unwrap()
            .then((payload) => {
                if (!payload.IsError) {
                    setConfigList(payload.configList)

                    if (!isNullOrEmpty(getConfigValue(payload.configList, "TicariKredi.Landing.DefaultProductValues"))) {
                        const parsedData: DefaultValues[] = JSON.parse(getConfigValue(payload.configList, "TicariKredi.Landing.DefaultProductValues"))
                        dispatch(
                            setCalcDetails({
                                minVade: parsedData[0]?.minVade,
                                maxVade: parsedData[0]?.maxVade,
                                minAmount: parsedData[0]?.minAmount,
                                maxAmount: parsedData[0]?.maxAmount,
                            })
                        )
                    }

                    if (!isNullOrEmpty(getConfigValue(payload.configList, "TicariKredi.Landing.Faq"))) {
                        setFaqText(JSON.parse(getConfigValue(payload.configList, "TicariKredi.Landing.Faq")))
                    }
                }
            })
    }, [])

    useEffect(() => {
        pushGtmValues({
            event: 'virtual_page_view',
            content_group: 'ticari_kredi_basvurusu',
            pageName: '/basvuru/ticari-kredi/0/landing',
            pageTitle: 'ticari kredi basvurusu'
        })
    }, []);

    const showCalcDetails = useAppSelector((state) => state.calcDetails.response?.showCalcDetails)
    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader configValue={getConfigValue(configList, "TicariKredi.CampaignText.Landing.Top")} />
            <Grid type="main" className="landing-page-main">
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <CalculateForm />
                    </Col>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        {showCalcDetails && <CalculationDetail />}
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        {faqText && <SSSList faqText={faqText} />}
                    </Col>
                </Row>
            </Grid>
        </Block>
    )
}

export default Landing
